import React from 'react';

import style from './CountryCode.module.scss';

type CountryCodeProps = {
  code: string;
  name: string;
};

const CountryCode: React.FC<CountryCodeProps> = ({ name, code }) => {
  return (
    <div className={style.container}>
      <div className={style.dialCode}>{code}</div>
      <div className={style.name}>{name}</div>
    </div>
  );
};

export default CountryCode;
